import { requestTaskApi } from './requestTask.js'

export const moveFileOptimisticUpdate = async (
  { requestTaskId, fileId, fromDocumentId, toDocumentId },
  { dispatch, queryFulfilled },
) => {
  // Optimistic update
  const patchResult = dispatch(
    requestTaskApi.util.updateQueryData(
      'getRequestTask',
      requestTaskId,
      draft => {
        const { requestTask } = draft
        if (!requestTask) {
          return
        }

        // Move file logic
        let fileToMove = null

        if (fromDocumentId === 'unmatched') {
          const fileIndex = requestTask.unmatched_files?.findIndex(
            f => String(f._id) === String(fileId),
          )
          if (fileIndex !== -1) {
            fileToMove = requestTask.unmatched_files[fileIndex]
            requestTask.unmatched_files.splice(fileIndex, 1)
          }
        } else {
          const fromDoc = requestTask.documents.find(
            doc => String(doc.id) === String(fromDocumentId),
          )
          if (fromDoc?.files) {
            const fileIndex = fromDoc.files.findIndex(
              f => String(f._id) === String(fileId),
            )
            if (fileIndex !== -1) {
              fileToMove = fromDoc.files[fileIndex]
              fromDoc.files.splice(fileIndex, 1)
            }
          }
        }

        if (fileToMove) {
          if (toDocumentId === null) {
            requestTask.unmatched_files = requestTask.unmatched_files || []
            requestTask.unmatched_files.push(fileToMove)
          } else {
            const toDoc = requestTask.documents.find(
              doc => String(doc.id) === String(toDocumentId),
            )
            if (toDoc) {
              toDoc.files = toDoc.files || []
              toDoc.files.push(fileToMove)
            }
          }
        }
      },
    ),
  )

  try {
    const { data } = await queryFulfilled
    // Update with server response
    dispatch(
      requestTaskApi.util.updateQueryData(
        'getRequestTask',
        requestTaskId,
        draft => {
          if (data.requestTask) {
            Object.assign(draft.requestTask, data.requestTask)
          }
        },
      ),
    )
  } catch {
    patchResult.undo()
  }
}
